// extracted by mini-css-extract-plugin
var _1 = "AnswerTooltip_content__64d6f";
var _2 = "AnswerTooltip_item__5c8e2";
var _3 = "AnswerTooltip_navigation__f3e46";
var _4 = "AnswerTooltip_root__71d49";
var _5 = "AnswerTooltip_title__3e294";
export { _1 as "content", _2 as "item", _3 as "navigation", _4 as "root", _5 as "title" }
